<template>
  <v-select
    id="announcement-stops"
    :rules="[value => !!value && value.length > 0 || 'Povinné']"
    v-model="stops"
    :items="allStops"
    item-title="stopName"
    item-value="stopName"
    chips
    color="default"
    label="Zobrazované zastávky"
    multiple
    :clearable="true"
    :menu-props="{ offsetY: true }"
    variant="underlined"
  >
    <template v-if="allStops.length > 0" v-slot:prepend-item>
      <v-list-item
        ripple
        @click="toggleSelectedStops"
      >
        <v-list-item-action>
          <v-icon :color="someStopsAdded || allStopsAdded ? 'blue-darken-2' : ''">{{ selectAllIcon }}</v-icon>
        </v-list-item-action>
        <v-list-item-title>{{allStopsAdded  ? 'Zrušit výběr' : 'Vybrat vše'}}</v-list-item-title>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
  </v-select>
</template>

<script setup>
import {computed, nextTick, onMounted, ref, toRaw, watch} from "vue";
import _ from "lodash";

const props = defineProps({
  initialValues: Object,
  allStops: Array,
  rules: Array
})

const emit = defineEmits(['stopsChanged'])

onMounted(()=>{
  emit('stopsChanged', { pristine: _.isEqual(props.initialValues?.stops, stops.value), value: { stops: toRaw(stops.value) }, valid: toRaw(stops.value).length > 0 });
})

const stops = ref(props.initialValues?.stops ?? [])

const selectAllIcon = computed(()=>{
  if (allStopsAdded.value) return 'check_box'
  if (someStopsAdded.value) return 'indeterminate_check_box'
  return 'check_box_outline_blank'
})

const allStopsAdded = computed(()=>{
  return (stops.value || []).length === props.allStops.length
})

const someStopsAdded = computed(()=>{
  return (stops.value || []).length > 0 && !allStopsAdded.value
})

function toggleSelectedStops () {
  nextTick(() => {
    if (allStopsAdded.value) {
      stops.value = []
    } else {
      stops.value = props.allStops.map((item) => item.stopName)
    }
  })
}

watch(stops, (value) => {
  emit('stopsChanged', { pristine: _.isEqual(props.initialValues?.stops, value), value: { stops: toRaw(value) }, valid: toRaw(value).length > 0 });
})

</script>
<style>
</style>